import React from "react";

interface ButtonWithSoundProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  className?: string;
  Icon?: React.ElementType;
  style?: React.CSSProperties;
  type?: "button" | "submit" | "reset";
}

export const ButtonWithSound: React.FC<ButtonWithSoundProps> = ({
  children,
  className = "",
  onClick,
  onMouseEnter,
  style,
  type = "button",
}) => {
  return (
    <button
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      style={style}
      type={type}
    >
      {children}
    </button>
  );
};
